import { render, staticRenderFns } from "./classifyList.vue?vue&type=template&id=1cac5944&scoped=true"
import script from "./classifyList.vue?vue&type=script&lang=js"
export * from "./classifyList.vue?vue&type=script&lang=js"
import style0 from "./classifyList.vue?vue&type=style&index=0&id=1cac5944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cac5944",
  null
  
)

export default component.exports